"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = require("./colors");
exports.default = {
    legal: {
        "color": "lightGreyMolamola",
        "fontFamily": "body",
        "fontSize": 0,
        "textDecoration": "none",
        ":hover": {
            color: "white"
        }
    },
    tabs: {
        "color": "white",
        "fontFamily": "body",
        "fontSize": 1,
        "lineHeight": 0,
        "textDecoration": "none",
        ":hover": {
            color: colors_1.mainColors.primary
        }
    }
};
